module.exports = __webpack_public_path__ + "img/404-error.e238f9c0.png";